import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Modal } from '@/components/Modal';
import { Typography } from '@/components/Typography';

import { NextImage } from '../NextImage';
export const Logo = styled(NextImage)`
  margin: ${({ theme }) => theme.spacing(2)};
`;

export const Body = styled(Typography)`
  text-align: center;
  max-width: 700px;

  ${({ theme }) => css`
    font-weight: ${theme.fontWeights.regular};
    margin: 0 auto ${theme.spacing(2)};
    scale: ${theme.fontSizes.p0};
    color: ${theme.colors.defaultAdd3};
    line-height: ${theme.lineHeights.p0};
  `}
`;

export const ContactUsTitle = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.spacing(3)};
    line-height: ${theme.spacing(3)};
    font-weight: ${theme.fontWeights.semibold};
    font-family: ${theme.fontFamilies.italianPlate};
    padding-bottom: ${theme.spacing(2.5)};
    ${theme.media.sm.up} {
      padding-bottom: ${theme.spacing(3)};
    }
  `}
`;
export const ProductImageBox = styled(Box)`
  &&& {
    max-height: 176px;
    aspect-ratio: 1;
    min-width: 176px;
    position: relative;
  }
`;
export const ProductCardBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  ${({ theme }) => css`
    padding: ${theme.spacing(2, 0, 0, 0.25)};
    ${theme.media.sm.up} {
      padding: ${theme.spacing(3, 0, 0, 0.25)};
      flex-direction: row;
    }
  `}
`;

export const ProductInfoBox = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ theme }) => css`
    margin-left: ${theme.spacing(0)};
    margin-top: ${theme.spacing(5)};
    align-items: center;
    text-align: center;
    ${theme.media.sm.up} {
      align-items: start;
      text-align: left;
      margin-left: ${theme.spacing(3)};
      margin-top: ${theme.spacing(0)};
    }
  `}
`;
export const ProductName = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.spacing(2.5)};
    line-height: ${theme.spacing(2.75)};
    font-weight: ${theme.fontWeights.semibold};
    font-family: ${theme.fontFamilies.italianPlate};
    text-transform: uppercase;
  `}
`;
export const ProductParametersBox = styled(Box)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};
  `}
`;
export const ProductParametersItem = styled(Box)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(0.5)};
    font-size: ${theme.fontSizes.p2};
    font-weight: ${theme.fontWeights.regular};
    line-height: ${theme.spacing(2.75)};
    font-family: ${theme.fontFamilies.openSans};
  `}
`;
export const ContactUsChildenBox = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ theme }) => css`
    font-size: ${theme.spacing(2.5)};
    line-height: ${theme.spacing(2.75)};
    font-weight: ${theme.fontWeights.medium};
    font-family: ${theme.fontFamilies.italianPlate};
    margin-top: ${theme.spacing(2)};
  `}
`;

export const ContactUsPhone = styled(Typography)`
  ${({ theme }) => css`
    color: ${theme.colors.primaryBlue};
    font-weight: ${theme.fontWeights.medium};
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.spacing(2.5)};
    line-height: ${theme.spacing(2.75)};
    margin-left: ${theme.spacing(1)};
    text-decoration: underline;
  `}
`;

export const ContactUsModalBody = styled(Modal.Body)`
  overflow: hidden;
`;
